import React from 'react';

import Dash from '../../components/Dash';

// import { Container } from './styles';

export default function Home() {
  return <Dash />;
}
